<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- general tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="InfoIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Konsultasi</span>
      </template>
      <!-- v-if="options.proyek"
      :data-proyek="options.proyek" -->
      <tiket :isDisabled="buttonClicked" @clicked="simpanTiket" />
    </b-tab>
    <!--/ general tab -->

    <b-tab
      v-if="
        this.$route.params.id &&
          this.rows.status_tiket_id !== 'e2281ff8-2558-11ee-acb1-3497f616f0' &&
          this.rows.status_tiket_id !== 'e2281ff8-2558-11ee-acb1-3497f616fe22'
      "
    >
      <template #title>
        <feather-icon icon="CalendarIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Form</span>
      </template>

      <form-tiket @clicked="simpanForm" :key="loadForm" />
    </b-tab>

    <!-- <b-tab
      v-if="this.$route.params.id"
    >
      <template #title>
        <feather-icon
          icon="BriefcaseIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Dokumen</span>
      </template>

      <view-dokumen-lainnya
        :user-data="rowData"
        :dataJenisDokumen="dataMasterJenisDokumenLainnya"
        :canManage="true"
        :jenisPermohonanId="jenisPermohonanId"
        :permohonanId="permohonanId"
        @emitReceiver="reloadData"
      />
    </b-tab>

    <b-tab
      v-if="this.$route.params.id"
    >
      <template #title>
        <feather-icon
          icon="BriefcaseIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Foto & Video</span>
      </template>

      <view-dokumen-foto
        :user-data="rowData"
        :dataJenisDokumen="dataMasterJenisDokumenFoto"
        :canManage="true"
        :jenisPermohonanId="jenisPermohonanId"
        :permohonanId="permohonanId"
        @emitReceiver="reloadData"
      />
    </b-tab> -->

    <b-tab v-if="this.rows && $can('assign', 'tiket') && showTabAssign" lazy>
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Assign</span>
      </template>

      <koordinator />
    </b-tab>

    <b-tab
      v-if="
        this.rows &&
          $can('assign', 'tiket') &&
          this.rows.status_tiket_id !== 'e2281ff8-2558-11ee-acb1-3497f616f0'
      "
    >
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Biodata</span>
      </template>

      <biodata />
    </b-tab>

    <!-- <b-tab
      v-if="this.$route.params.id"
    >
      <template #title>
        <feather-icon
          icon="MessageSquareIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Chat</span>
      </template>

      <card-advance-chat
        :keyId="this.$route.params.id"
        :keyTable="keyTable"
      />
    </b-tab> -->
    <!-- <b-tab
      v-if="this.$route.params.id && $can('tabuser', 'kegiatan')"
      :active="activeUser"
    >
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">User</span>
      </template>

      <user/>
    </b-tab>

    <b-tab
      v-if="this.$route.params.id && $can('tablink', 'kegiatan')"
    >
      <template #title>
        <feather-icon
          icon="Link2Icon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Link</span>
      </template>

      <form-link/>
    </b-tab> -->
    <b-toast />
  </b-tabs>
</template>

<script>
import { BTabs, BTab, BToast } from 'bootstrap-vue'
import router from '@/router'
// eslint-disable-next-line object-curly-newline
import { insTiket, ubahTiket, getTiket, uploadFileTiket } from '@/connection-api/tiket'
// import CardAdvanceChat from '@/views/layouts/CardAdvanceChat.vue'
import FormTiket from './form/FormTiket.vue'
import Tiket from './form/Tiket.vue'
import Koordinator from './form/Koordinator.vue'
import Biodata from './form/Biodata.vue'
// import ViewDokumenLainnya from './form/ViewDokumenLainnya.vue'
// import ViewDokumenFoto from './form/ViewDokumenFoto.vue'
import User from './form/User.vue'
import FormLink from './form/Link.vue'

export default {
  components: {
    BTabs,
    BTab,
    Tiket,
    FormTiket,
    Koordinator,
    Biodata,
    // ViewDokumenLainnya,
    // ViewDokumenFoto,
    // User,
    // FormLink,
    BToast,
    // CardAdvanceChat,
  },
  data() {
    return {
      options: {},
      keyTable: 'tiket',
      loadForm: 1,
      rows: {},
      userData: JSON.parse(localStorage.getItem('userData')),
      showTabAssign: false,
      buttonClicked: false,
    }
  },
  async mounted() {
    // console.log
    if (this.$route.params.id) {
      this.loadForm += 1
      let params = {}
      if (this.$can('proses', 'tiket')) {
        params = { proses: true }
      }
      // params = { proses: true }
      const response = await getTiket(this.$route.params.id, params)
      // if (response.data.userTiket.length > 0) {
      //   if (response.data.userTiket[0].user_id !== this.userData.id) {
      //     this.makeToast('danger', 'Data Sudah Ambil Oleh Helpdesk Lain')
      //     setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
      //   }
      // }
      this.rows = response.data.data
      if (this.rows.user_tiket_id === null) {
        const resp = await getTiket(this.$route.params.id, params)
        this.rows.status_tiket_id = resp.data.data.status_tiket_id
      }

      // console.log(this.rows.status_tiket_id)
      // || this.rows.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe7'
      // || this.rows.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe8'
      if (this.rows.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe6') {
        this.showTabAssign = true
      } else {
        this.showTabAssign = false
      }

      if (
        // eslint-disable-next-line operator-linebreak
        !this.$can('proses', 'tiket') &&
        this.rows.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616f4'
      ) {
        this.makeToast('danger', 'Data Tidak Bisa di Ubah Karna Sedang di Proses Oleh Helpdesk')
        setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
      }
      // console.log(response.data.userTiket.indexOf('914'))
      // console.log(response.data.userTiket.indexOf('911'))
      // console.log(this.userData.id)
      // console.log(response.data.userTiket.length)
      // console.log(response.data.userTiket[0].user_id)

      this.$emit('loaded', this.rows)
    }
  },
  methods: {
    async simpanTiketOld(value) {
      try {
        // value.proyek_id = value.select_proyek.selected
        const response = await insTiket(value)
        // console.log(response)
        if (value.tiket_id) {
          this.makeToast('success', 'Ubah Tiket Berhasil!')
        } else {
          this.makeToast('success', 'Tambah Tiket Berhasil!')
          setTimeout(
            () =>
              // eslint-disable-next-line implicit-arrow-linebreak
              this.$router.push({
                name: 'pages-tiket-ubah',
                params: { id: response.data.tiket_id },
              }),
            500,
          )
        }
      } catch (error) {
        this.makeToast('danger', error.response.data.data)
        this.show = false
      }
      this.loadForm += 1
    },
    async simpanTiketold2(value) {
      let imagefilename = ''
      // console.log(value.File)
      if (value.File) {
        // Update File
        const responseUpload = await uploadFileTiket(value.File, 'tiket', event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        })
        imagefilename = responseUpload.data.filename

        if (responseUpload.data.filename !== undefined) {
          if (value.File) {
            value.img = imagefilename
            delete value.File
          }
          try {
            const response = await insTiket(value)
            if (value.tiket_id) {
              this.makeToast('success', 'Ubah Tiket Berhasil!')
              // if (response.data.button === 'kirim') {
              setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
              // }
            } else {
              this.makeToast('success', 'Tambah Tiket Berhasil!')
              setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
              // setTimeout(() => this.$router.push({ name: 'pages-tiket-ubah', params: { id: response.data.tiket_id } }), 500)
            }
          } catch (error) {
            this.makeToast('danger', error.response.data.data)
            // console.log(error.response.data)
            if (error.response.data.message === '002') {
              setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
            }
            this.show = false
          }
          this.loadForm += 1
        } else {
          this.makeToast('danger', responseUpload.data.data)
          this.show = false
        }
      } else {
        if (value.File) {
          value.img = imagefilename
          delete value.File
        }
        try {
          const response = await insTiket(value)
          if (value.tiket_id) {
            this.makeToast('success', 'Ubah Tiket Berhasil!')
            // console.log('243')
            // console.log(response.data.tiket_id)
            // console.log(response.button)
            // console.log(response.data.button)
            // console.log(response.data)
            // console.log(response.data.data)
            // console.log(value.tiket_id)
            if (response.data.button === 'draft') {
              // console.log(re)
              setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
            }
          } else {
            this.makeToast('success', 'Tambah Tiket Berhasil!')
            setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
            // setTimeout(() => this.$router.push({ name: 'pages-tiket-ubah', params: { id: response.data.tiket_id } }), 500)
          }
        } catch (error) {
          this.makeToast('danger', error.response.data.data)
          if (error.response.data.message === '002') {
            setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
          }
          this.show = false
        }
        this.loadForm += 1
      }
    },
    async simpanTiket(value) {
      let imagefilename = ''
      // console.log(value.File)
      this.buttonClicked = true
      if (value.File) {
        // Update File
        const responseUpload = await uploadFileTiket(value.File, 'tiket', event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        })
        imagefilename = responseUpload.data.filename

        if (responseUpload.data.filename !== undefined) {
          if (value.File) {
            value.img = imagefilename
            delete value.File
          }
          try {
            const response = await insTiket(value)
            if (response.data.success === true) {
              if (value.tiket_id) {
                this.makeToast('success', 'Ubah Tiket Berhasil!')
                setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
              } else {
                this.makeToast('success', 'Tambah Tiket Berhasil!')
                setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
              }
            } else {
              this.makeToast('danger', response.data.data)
              if (response.data.message === '002') {
                setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
              }
              this.show = false
            }
          } catch (error) {
            this.makeToast('danger', error.response.data.data)
            if (error.response.data.message === '002') {
              setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
            }
            this.show = false
          }
          this.loadForm += 1
        } else {
          this.makeToast('danger', responseUpload.data.data)
          this.show = false
        }
      } else {
        if (value.File) {
          value.img = imagefilename
          delete value.File
        }
        try {
          const response = await insTiket(value)
          if (response.data.success === true) {
            if (value.tiket_id) {
              this.makeToast('success', 'Ubah Tiket Berhasil!')
              setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
            } else {
              this.makeToast('success', 'Tambah Tiket Berhasil!')
              setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
            }
          } else {
            this.makeToast('danger', response.data.data)
            if (response.data.message === '002') {
              setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
            }
            this.show = false
          }
        } catch (error) {
          this.makeToast('danger', error.response.data.data)
          if (error.response.data.message === '002') {
            setTimeout(() => this.$router.push({ name: 'pages-tiket' }), 2000)
          }
          this.show = false
        }
        this.loadForm += 1
      }

      this.buttonClicked = false
    },
    async simpanForm(value) {
      // console
      value.form = 'form'
      if (value.id) {
        const response = await ubahTiket(value)
        if (response.data.status.code === '00') {
          // console.log(response.data.data.status_tiket_id)
          // console.log(response.data.countDataUserTiketTidakAktif)
          // console.log(response.data.countDataUseriketAktif)
          this.makeToast('success', 'Lengkapi Data Berhasil!')
          if (
            // eslint-disable-next-line operator-linebreak
            response.data.countDataUseriketAktif === 0 &&
            response.data.data.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe6'
          ) {
            this.makeToast('danger', 'Silahkan Isi Tab Assign')
          } else if (
            // eslint-disable-next-line operator-linebreak
            response.data.countDataUseriketAktif > 0 &&
            response.data.data.status_tiket_id !== 'e2281ff8-2558-11ee-acb1-3497f616fe6'
          ) {
            this.makeToast('success', 'Data Helpdesk Berhasil Di hapus')
          }
          if (response.data.data.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe6') {
            this.showTabAssign = true
          } else {
            this.showTabAssign = false
          }
        } else {
          this.makeToast('danger', response.data.data)
          this.show = false
        }
        // this.makeToast('danger', error.response.data)
        // this.show = false
      }
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Tiket',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
  },
  beforeCreate() {
    // this.$http.get('/kegiatan/data').then(res => { this.options = res.data })
  },
}
</script>
